import {authRoles} from 'app/auth';
import React from 'react';

export const SaleAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.staff,
    routes  : [
        {
            path     : '/sales',
            component: React.lazy(() => import('./SaleApp'))
        }
    ]
};
